var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPinned = function SvgPinned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.478 3.22a.75.75 0 0 0-1.28.53v2.871l-3.863 3.863-5.08 1.016a.75.75 0 0 0-.384 1.266l3.182 3.182-3.712 3.712a.75.75 0 1 0 1.06 1.06l3.713-3.712 3.182 3.182a.75.75 0 0 0 1.265-.383l1.017-5.08 3.862-3.863h2.871a.75.75 0 0 0 .53-1.28L14.479 3.22Z"
  })));
};

export default SvgPinned;